import { Translation } from '@ps/web-shared-components';
import React from 'react';

import useParticipants from '@swf/sports/hooks/useParticipants';

import { TXTWCL_N0_vs_N1 } from './EventName.messages.json';
import styles from './EventName.scss';

const EventName: React.FC<{ eventName: string }> = ({ eventName }) => {
  const [home, away] = useParticipants(eventName)?.map(({ participant }) => participant) ?? [];

  if (home && away) {
    return (
      <h3 className={styles.participants}>
        <span className={styles.home}>{home}</span>
        <span className={styles.srOnly}>
          <Translation {...TXTWCL_N0_vs_N1} values={{ 0: '', 1: '' }} />
        </span>
        <span>{away}</span>
      </h3>
    );
  }

  return <h3 className={styles.participants}>{eventName}</h3>;
};

export default EventName;
